import "bootstrap";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).select2({
      allowClear: true,
      minimumInputLength: 3,
      tags: true,
      theme: 'bootstrap',
      language: 'pt-BR'})

  }
}
